import { faEnvelope, faLock, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import Badge from "../../common/badge/Badge";
import { Column, Row } from "../../common/columns";
import DashboardItem from "../../common/dashboard/DashboardItem";
import { UserContext } from "../../common/user/UserContext";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../common/theme/ThemeContext";

function DashboardPage() {
  const user = useContext(UserContext);
  const { t } = useTranslation();
  const theme = useContext(ThemeContext);

  return (
    <div className="container">
      <Row>
        <Column>
          <DashboardItem link="/submitRequest" label={t("requests.submit")} labelSize="3">
            <FontAwesomeIcon
              size="3x"
              className={`has-text-${theme.iconColor} mt-2`}
              icon={faPlusCircle}
            />
          </DashboardItem>
        </Column>
        <Column>
          <DashboardItem link="/requests" label={t("requests.created")} labelSize="3">
            <Badge
              value={user.pendingRequests}
              icon={faEnvelope}
              iconBulmaColor={theme.iconColor}
              size="1"
              iconSize="3"
              className="mt-2"
            />
          </DashboardItem>
        </Column>
        <Column>
          <DashboardItem link="/archive" label={t("requests.archive")} labelSize="3">
            <FontAwesomeIcon
              size="3x"
              className={`has-text-${theme.iconColor} mt-2`}
              icon={faLock}
            />
          </DashboardItem>
        </Column>
      </Row>
    </div>
  );
}

export default DashboardPage;
